import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import V2StructuredPrompt from "../../../assets/Fibo/images/A_graphic_showing_a__TXT__icon_and_a_photo_icon_with_an_arrow_pointing_to_a_more.png";
import V2GenerateImagePro from "../../../assets/Fibo/images/A_split_image__on_the_left__a_more_complex_input_like_a_reference_image_plus_a_n.png";
import V2GenerateImageLite from "../../../assets/Fibo/images/ChatGPT Image Oct 27, 2025, 03_50_16 PM.png";
import V2StructuredPromptLite from "../../../assets/Fibo/images/Gemini_Generated_Image_kf8cvrkf8cvrkf8c.jpg";
// import BaseModel from "../../../assets/ImageGeneration/images/api-base-model.jpg";
// import FastModel from "../../../assets/ImageGeneration/images/api-fast-model.jpg";
// import HDModel from "../../../assets/ImageGeneration/images/api-hd-model.jpg";
// import PromptEnhance from "../../../assets/ImageGeneration/images/api-prompt-enhancement.jpg";
// import Reimagine from "../../../assets/ImageGeneration/images/api-reimagine.jpg";
// import VectorBase from "../../../assets/ImageGeneration/images/api-vector-base.jpg";
// import VectorFast from "../../../assets/ImageGeneration/images/api-vector-fast.jpg";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";
import { POSTHOG_EVENTS } from "../../../constants/PostHogEvents";
import RouterConstants from "../../../constants/RouterConstants";
import { ORG_SUBSCRIPTION_PLANS } from "../../../constants/billing";
import { usePostHog } from "../../../hooks/usePostHog";
import { useAppStore } from "../../../hooks/useStores";

const ImageGenerationAPI = () => {
	const { t } = useTranslation("translation", { keyPrefix: "imageGeneration.api" });
	const { authStore } = useAppStore();
	const currentPlanName = authStore?.orgSubscription?.plan_name;
	const { trackEvent } = usePostHog();
	const navigate = useNavigate();

	const openDocs = (link: string) => {
		// Track API documentation viewed
		trackEvent(POSTHOG_EVENTS.API_DOCUMENTATION_VIEWED, {
			section: getSectionFromLink(link),
		});

		window.open(link, "_blank");
	};

	// Helper to extract section name from link
	const getSectionFromLink = (link: string): string => {
		const sectionMap: { [key: string]: string } = {
			[LinkConstants.IMAGE_GENERATION.BASE.DOCS]: "Base Model",
			[LinkConstants.IMAGE_GENERATION.HD.DOCS]: "HD Model",
			[LinkConstants.IMAGE_GENERATION.VECTOR_FAST.DOCS]: "Vector Fast",
			[LinkConstants.IMAGE_GENERATION.PROMPT_ENHANCEMENT.DOCS]: "Prompt Enhancement",
			[LinkConstants.IMAGE_GENERATION.FAST.DOCS]: "Fast Model",
			[LinkConstants.IMAGE_GENERATION.VECTOR_BASE.DOCS]: "Vector Base",
			[LinkConstants.IMAGE_GENERATION.REIMAGINE.DOCS]: "Reimagine",
			[LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE.DOCS]: "V2 Generate Image",
			[LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE_PRO.DOCS]: "V2 Generate Image Pro",
			[LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE.DOCS]: "V2 Structured Prompt",
			[LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE_PRO.DOCS]: "V2 Structured Prompt Pro",
		};

		return sectionMap[link] || "Unknown Section";
	};

	const rightActions = (
		<>
			<BriaButton buttonType="secondarySmall" onClick={() => navigate(RouterConstants.ACCOUNT_IFRAMES.fullPath)}>
				{t("headerButtons.configureIframe")}
			</BriaButton>
			<BriaButton
				buttonType="secondarySmall"
				onClick={() => navigate(RouterConstants.IMAGE_GENERATION.DEMO.IMAGE_GENERATION.fullPath)}
			>
				{t("headerButtons.playground")}
			</BriaButton>
		</>
	);

	const v2ApiCards: ConsoleAPICardProps[] = [
		// {
		// 	image: V2GenerateImage,
		// 	header: t("v2Cards.generateImage.header"),
		// 	description: t("v2Cards.generateImage.description"),
		// 	buttons: (
		// 		<BriaButton
		// 			buttonType="textSmall"
		// 			onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE.DOCS)}
		// 		>
		// 			{t("v2Cards.common.primaryBtn")}
		// 		</BriaButton>
		// 	),
		// 	onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE.DOCS),
		// },
		{
			image: V2GenerateImagePro,
			header: t("v2Cards.generateImage.header"),
			description: t("v2Cards.generateImagePro.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE.DOCS)}
					>
						{t("v2Cards.common.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE.COMFY_UI.NODE, "_blank")
						}
					>
						{t("v2Cards.common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE.DOCS),
		},
		// {
		// 	image: V2StructuredPrompt,
		// 	header: t("v2Cards.structuredPrompt.header"),
		// 	description: t("v2Cards.structuredPrompt.description"),
		// 	buttons: (
		// 		<BriaButton
		// 			buttonType="textSmall"
		// 			onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE.DOCS)}
		// 		>
		// 			{t("v2Cards.common.primaryBtn")}
		// 		</BriaButton>
		// 	),
		// 	onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE.DOCS),
		// },
		{
			image: V2StructuredPrompt,
			header: t("v2Cards.structuredPrompt.header"),
			description: t("v2Cards.structuredPromptPro.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE.DOCS)}
					>
						{t("v2Cards.common.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(
								LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE.COMFY_UI.NODE,
								"_blank",
							)
						}
					>
						{t("v2Cards.common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE.DOCS),
		},
		{
			image: V2GenerateImageLite,
			header: t("v2Cards.generateImageLite.header"),
			description: t("v2Cards.generateImageLite.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE_LITE.DOCS)}
					>
						{t("v2Cards.common.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE_LITE.COMFY_UI.NODE, "_blank")
						}
					>
						{t("v2Cards.common.comfyNodeBtn")}
					</BriaButton>
					{currentPlanName === ORG_SUBSCRIPTION_PLANS.custom.name && (
						<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.FIBO_LITE_GITHUB)}>
							{t("v2Cards.common.secondButton")}
						</BriaButton>
					)}
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.V2.GENERATE_IMAGE_LITE.DOCS),
		},

		{
			image: V2StructuredPromptLite,
			header: t("v2Cards.generateStructuredPromptLite.header"),
			description: t("v2Cards.generateStructuredPromptLite.description"),
			buttons: (
				<>
					<BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE_LITE.DOCS)}
					>
						{t("v2Cards.common.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						onClick={() =>
							window.open(
								LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE_LITE.COMFY_UI.NODE,
								"_blank",
							)
						}
					>
						{t("v2Cards.common.comfyNodeBtn")}
					</BriaButton>
				</>
			),
			onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.V2.STRUCTURED_PROMPT_GENERATE_LITE.DOCS),
		},
	];

	// const imageGenerationApiCards: ConsoleAPICardProps[] = [
	// 	{
	// 		image: BaseModel,
	// 		header: t("cards.baseModel.header"),
	// 		description: t("cards.baseModel.description"),
	// 		buttons: (
	// 			<>
	// 				<BriaButton
	// 					buttonType="textSmall"
	// 					onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.BASE.DOCS)}
	// 				>
	// 					{t("cards.baseModel.primaryBtn")}
	// 				</BriaButton>
	// 				<BriaButton
	// 					buttonType="textSmall"
	// 					onClick={() => window.open(LinkConstants.IMAGE_GENERATION.BASE.COMFY_UI.NODE, "_blank")}
	// 				>
	// 					{t("v2Cards.common.comfyNodeBtn")}
	// 				</BriaButton>
	// 			</>
	// 		),
	// 		onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.BASE.DOCS),
	// 	},
	// 	{
	// 		image: HDModel,
	// 		header: t("cards.hdModel.header"),
	// 		description: t("cards.hdModel.description"),
	// 		buttons: (
	// 			<>
	// 				<BriaButton buttonType="textSmall" onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.HD.DOCS)}>
	// 					{t("cards.hdModel.primaryBtn")}
	// 				</BriaButton>
	// 				<BriaButton
	// 					buttonType="textSmall"
	// 					onClick={() => window.open(LinkConstants.IMAGE_GENERATION.HD.COMFY_UI.NODE, "_blank")}
	// 				>
	// 					{t("v2Cards.common.comfyNodeBtn")}
	// 				</BriaButton>
	// 			</>
	// 		),
	// 		onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.HD.DOCS),
	// 	},
	// 	{
	// 		image: VectorFast,
	// 		header: t("cards.vectorFast.header"),
	// 		description: t("cards.vectorFast.description"),
	// 		buttons: (
	// 			<BriaButton
	// 				buttonType="textSmall"
	// 				onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.VECTOR_FAST.DOCS)}
	// 			>
	// 				{t("cards.vectorFast.primaryBtn")}
	// 			</BriaButton>
	// 		),
	// 		onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.VECTOR_FAST.DOCS),
	// 	},
	// 	{
	// 		image: PromptEnhance,
	// 		header: t("cards.promptEnhance.header"),
	// 		description: t("cards.promptEnhance.description"),
	// 		buttons: (
	// 			<BriaButton
	// 				buttonType="textSmall"
	// 				onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.PROMPT_ENHANCEMENT.DOCS)}
	// 			>
	// 				{t("cards.promptEnhance.primaryBtn")}
	// 			</BriaButton>
	// 		),
	// 		onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.PROMPT_ENHANCEMENT.DOCS),
	// 	},
	// 	{
	// 		image: FastModel,
	// 		header: t("cards.fastModel.header"),
	// 		description: t("cards.fastModel.description"),
	// 		buttons: (
	// 			<>
	// 				<BriaButton
	// 					buttonType="textSmall"
	// 					onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.FAST.DOCS)}
	// 				>
	// 					{t("cards.fastModel.primaryBtn")}
	// 				</BriaButton>
	// 				<BriaButton
	// 					buttonType="textSmall"
	// 					onClick={() => window.open(LinkConstants.IMAGE_GENERATION.FAST.COMFY_UI.NODE, "_blank")}
	// 				>
	// 					{t("v2Cards.common.comfyNodeBtn")}
	// 				</BriaButton>
	// 			</>
	// 		),
	// 		onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.FAST.DOCS),
	// 	},
	// 	{
	// 		image: VectorBase,
	// 		header: t("cards.vectorBase.header"),
	// 		description: t("cards.vectorBase.description"),
	// 		buttons: (
	// 			<BriaButton
	// 				buttonType="textSmall"
	// 				onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.VECTOR_BASE.DOCS)}
	// 			>
	// 				{t("cards.vectorBase.primaryBtn")}
	// 			</BriaButton>
	// 		),
	// 		onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.VECTOR_BASE.DOCS),
	// 	},
	// 	{
	// 		image: Reimagine,
	// 		header: t("cards.reimagine.header"),
	// 		description: t("cards.reimagine.description"),
	// 		buttons: (
	// 			<>
	// 				<BriaButton
	// 					buttonType="textSmall"
	// 					onClick={() => openDocs(LinkConstants.IMAGE_GENERATION.REIMAGINE.DOCS)}
	// 				>
	// 					{t("cards.reimagine.primaryBtn")}
	// 				</BriaButton>
	// 				<BriaButton
	// 					buttonType="textSmall"
	// 					onClick={() => window.open(LinkConstants.IMAGE_GENERATION.REIMAGINE.COMFY_UI.NODE, "_blank")}
	// 				>
	// 					{t("v2Cards.common.comfyNodeBtn")}
	// 				</BriaButton>
	// 			</>
	// 		),
	// 		onClick: () => openDocs(LinkConstants.IMAGE_GENERATION.REIMAGINE.DOCS),
	// 	},
	// ];

	return (
		<ConsoleAPILayout rightActions={rightActions} showIntegrationKeyButton>
			<ConsoleAPICards cards={v2ApiCards} />
			{/* <ConsoleAPICards title={t("v1Section.title")} cards={imageGenerationApiCards} /> */}
		</ConsoleAPILayout>
	);
};

export default observer(ImageGenerationAPI);
